import React, {PropTypes} from 'react';
import Link from 'shared/Link.jsx';
import classNames from 'classnames';
import DisplayIf from 'shared/DisplayIf.jsx';
import AuditSearchTournamentListContainer from './tournamentAudit/AuditSearchTournamentListContainer.jsx';
import AuditSearchCaptainListContainer from './captainAudit/AuditSearchCaptainListContainer.jsx';
import AuditSearchEntryListContainer from './entryAudit/AuditSearchEntryListContainer.jsx';
import AuditSearchVirtualEntryListContainer from './virtualEntryAudit/AuditSearchVirtualEntryListContainer.jsx';
import AuditSearchBowlerListContainer from './bowlerAudit/AuditSearchBowlerListContainer.jsx';
import {
  ADMIN_AUDIT_TAB_TOURNAMENTS_LABEL,
  ADMIN_AUDIT_TAB_CAPTAINS_LABEL,
  ADMIN_AUDIT_TAB_TEAMS_LABEL,
  ADMIN_AUDIT_TAB_VIRTUAL_ENTRIES_LABEL,
  ADMIN_AUDIT_TAB_BOWLERS_LABEL
} from './constants';

const AuditHome = ({
  actions,
  selectedAction,
  onSelectAuditTab
}) => (
  <div className="animated fadeIn"> 
    <div className="row">
      <div className="col-sm-3 col-lg-2">
        <div className="left-navigation-bar">
          {actions.map((action, index) => (
            <div
            key={index}>
              <Link
                to={action.to}
                className={classNames(
                  "btn",
                  {"btn-default": !action.active},
                  {"btn-primary": action.active} 
                )}
                onClick={() => onSelectAuditTab(action)}>
                {action.label  }
              </Link>
            </div>
          ))}
          <br/>
        </div>
      </div>
      <div className="col-sm-9 col-lg-10">
        <DisplayIf condition={selectedAction.label == ADMIN_AUDIT_TAB_TOURNAMENTS_LABEL} 
                   className="animated fadeIn">
          <AuditSearchTournamentListContainer /> 
        </DisplayIf>
        <DisplayIf condition={selectedAction.label == ADMIN_AUDIT_TAB_CAPTAINS_LABEL} 
                   className="animated fadeIn">
          <AuditSearchCaptainListContainer /> 
        </DisplayIf>
        <DisplayIf condition={selectedAction.label == ADMIN_AUDIT_TAB_TEAMS_LABEL} 
                   className="animated fadeIn">
          <AuditSearchEntryListContainer /> 
        </DisplayIf>
        <DisplayIf condition={selectedAction.label == ADMIN_AUDIT_TAB_VIRTUAL_ENTRIES_LABEL} 
                   className="animated fadeIn">
          <AuditSearchVirtualEntryListContainer /> 
        </DisplayIf>
        <DisplayIf condition={selectedAction.label == ADMIN_AUDIT_TAB_BOWLERS_LABEL} 
                   className="animated fadeIn">
          <AuditSearchBowlerListContainer /> 
        </DisplayIf> 
      </div>
    </div>
  </div>
);

AuditHome.defaultProps = { 
};

AuditHome.propTypes = { 
  actions: PropTypes.arrayOf(PropTypes.object),
  selectedAction: PropTypes.object,
  onSelectAuditTab: PropTypes.func
};

export default AuditHome;



// WEBPACK FOOTER //
// ./src/features/admin/audit/AuditHome.jsx